import { useState, type CSSProperties } from "react"
import { SidebarNav } from "@/polymet/components/sidebar-nav"
import { AdminHeader } from "@/polymet/components/admin-header"
import { cn } from "@/lib/utils"

interface AdminLayoutProps {
  children: React.ReactNode
  pageTitle?: string
  pageDescription?: string
}

export function AdminLayout({ children, pageTitle, pageDescription }: AdminLayoutProps) {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false)
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)
  const layoutStyle = {
    "--admin-sidebar-width": isSidebarCollapsed ? "5rem" : "16rem",
  } as CSSProperties

  return (
    <div
      className="flex min-h-screen bg-gradient-to-br from-[#F5F5F5] to-[#FAFAFA]"
      style={layoutStyle}
    >
      <SidebarNav 
        isCollapsed={isSidebarCollapsed} 
        isMobileOpen={isMobileSidebarOpen}
        onMobileClose={() => setIsMobileSidebarOpen(false)}
      />
      <div className={cn(
        "flex min-h-screen min-w-0 flex-1 flex-col transition-[padding] duration-300 ease-[cubic-bezier(0.22,1,0.36,1)]",
        "lg:pl-[var(--admin-sidebar-width)]"
      )}>
        <AdminHeader 
          onToggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          onMobileMenuToggle={() => setIsMobileSidebarOpen(!isMobileSidebarOpen)}
          isSidebarCollapsed={isSidebarCollapsed}
          title={pageTitle}
          description={pageDescription}
        />
        <main className="min-w-0 flex-1">
          {children}
        </main>
      </div>
    </div>
  )
}
